module.exports = __webpack_public_path__ + "img/banner3.39b8a732.png";